/**
 * 个股图表快捷时间范围选项（1M ~ 10Y），value 与 {@link STOCK_CHART_DATE_FILTER_RANGES} 下标对齐。
 */
export const STOCK_CHART_DATE_FILTER_OPTIONS = Object.freeze([
  { value: 0, label: '1M' },
  { value: 1, label: '3M' },
  { value: 2, label: '6M' },
  { value: 3, label: '1Y' },
  { value: 4, label: '3Y' },
  { value: 5, label: '5Y' },
  { value: 6, label: '10Y' }
]);

/**
 * 快捷时间范围对应的可视区间参数，与 {@link STOCK_CHART_DATE_FILTER_OPTIONS} 下标对齐。
 */
export const STOCK_CHART_DATE_FILTER_RANGES = Object.freeze([
  { number: 1, unit: 'M' },
  { number: 3, unit: 'M' },
  { number: 6, unit: 'M' },
  { number: 1, unit: 'y' },
  { number: 3, unit: 'y' },
  { number: 5, unit: 'y' },
  { number: 10, unit: 'y' }
]);
